<template>
    <div class="text-center">
        <v-dialog v-model="dialog"
                  width="550">

            <v-card>
                <v-card-title class="text-h5 orange darken-2 white--text py-2">
                    creditos del q10
                </v-card-title>

                <v-card-text>
                    <v-data-table 
                        :headers="headers"
                        :items="deuda_q10.Cuotas"
                        :items-per-page="100"
                        hide-default-footer
                        class="elevation-0"
                    ></v-data-table> 
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="success"
                           outlined
                           @click="guardar()">
                        <v-icon small
                                left> mdi-check </v-icon>
                        confirmar
                    </v-btn>
                    <v-btn color="red"
                           outlined
                           @click="cerrar()">
                        <v-icon small
                                left> mdi-close </v-icon>
                        Cerrar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
export default {
    data() {
        return {
            dialog: false,
            resolvePromise: null,
            deuda_q10:{Cuotas:[]},
            headers: [
                { text: 'Fecha_cuota', value: 'Fecha_cuota' }, 
                { text: 'Numero_cuota', value: 'Numero_cuota' }, 
                { text: 'Capital', value: 'Capital' }, 
                { text: 'Pagado', value: 'Pagado' }, 
                { text: 'Pendiente', value: 'Pendiente' }, 
            ],
        };
    },
    methods: {
        openmodal(deuda_q10) {
            const d = JSON.parse(JSON.stringify(deuda_q10));
            d.Cuotas.map(x=>(
                x.Fecha_cuota = this.formatearfecha(x.Fecha_cuota),
                x.Capital = '$ '+x.Capital,
                x.Pagado = '$ '+x.Pagado,
                x.Pendiente = '$ '+x.Pendiente
            ))
            this.deuda_q10 = d
            this.dialog = true;
            return new Promise((resolve) => {
                this.resolvePromise = resolve;
            });
        },
        formatearfecha(iso){
            const [year, month, day] = iso.split("T")[0].split("-");
            const formateada = `${day}/${month}/${year}`;
            return formateada;
        },
        cerrar() {
            this.resolvePromise(false);
            this.dialog = false;
        },
        guardar() {
            this.resolvePromise(true);
            this.dialog = false;
        },
    },
};
</script>